import { resolver } from '@/helpers/async';

declare global {
    interface Window {
        onYouTubeIframeAPIReady: () => void;
    }
}

const [ready, resolveReady] = resolver();

window.onYouTubeIframeAPIReady = async () => {
    resolveReady();
};

export const YoutubeIframeAPI = {
    ready,

    load() {
        if (document.querySelector('#youtube-iframe-api')) {
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.youtube.com/iframe_api';
        script.id = 'youtube-iframe-api';
        document.body.appendChild(script);
    },
};
